import { PresenceAttendanceState } from './types';

export const state = (): PresenceAttendanceState => initialState();

export const initialState = (): PresenceAttendanceState => ({
  presenceAttendances: {
    items: [],
    isLoading: false,
    total: 0,
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: [''],
    },
  },
});
